import { IOType } from '@erp/shared-types/node-graph';

interface IOSpanProps {
  ioType: IOType;
  text: string;
}

export function IOSpan({ ioType, text }: IOSpanProps) {
  return (
    <p
      className={`text-xs mt-0 mb-1 ${
        ioType === IOType.INPUT ? 'text-left' : 'text-right'
      }`}
    >
      {text}
    </p>
  );
}
